import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { creatorListingsPath, productCreatorStagePath } from "@travily/routes";
import type ListingsCreatorDescription from "@travily/types/pages/ListingsCreatorDescription";
import { firstError } from "@/lib/forms/first-error";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ProductDescriptionStepView } from "./show.view";

type PageProps = ListingsCreatorDescription;

type FormData = {
  description: string;
};

const ProductDescriptionStep = ({ listing_id, stage_index, stage_order, description }: PageProps) => {
  const { form, validate, currentStage, totalStages, onBack, onPrimary, primaryPending } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => productCreatorStagePath(listing_id, stage),
      entryUrl: creatorListingsPath(),
    },
    stageName: "description",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { description: description ?? "" },
  });

  const topBarActions = useCreatorTopBarActions({ saveHref: creatorListingsPath() });

  return (
    <>
      <Head title={t("web.products.creator.steps.description.show.meta_title")}>
        <meta name="description" content={t("web.products.creator.steps.description.show.meta_description")} />
      </Head>
      <ProductDescriptionStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        description={form.data.description}
        error={firstError(form.errors.description as string | string[] | undefined)}
        onDescriptionChange={(html) => {
          form.setData("description", html);
          validate("description");
        }}
      />
    </>
  );
};

export default ProductDescriptionStep;
